import { SET_SIDENAV_SLIM } from '../actions/settings';

const initialState = {
    isSidenavSlim: false,
};

const settings = (state = initialState, action) => {
    switch (action.type) {
        case SET_SIDENAV_SLIM:
            return {
                ...state,
                isSidenavSlim: action.isSidenavSlim,
            };
        default:
            return state;
    }
};

export default settings;
